import React, { useState, useEffect } from "react";
import "./generatebody.css";
import Sidebar from "../GenerateSidebar/MainSidebar/GenerateSidebar";
import ResultBox from "../../GenerateBody/ResultBox/MainResultBox/ResultBox";
import ShareIcon from "@material-ui/icons/Share";
import GetAppIcon from "@material-ui/icons/GetApp";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import BookmarkBorderSharpIcon from "@material-ui/icons/BookmarkBorderSharp";
import DeleteIcon from "@material-ui/icons/Delete";
import { IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { FormControlLabel } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { CSVLink } from 'react-csv';
// import { GENERATE_LINKEDINAD_RESET } from '../../../../constants/generateConstants';
// import Axios from "../../../../config/Axios";

function MainSoftware({ resultBox, sidebar, type, setGenerateArray, bookmarkArray, setBookmarkArray, isBookmarked, setIsBookmarked }) {
  const { fileId } = useParams();
  const [resultText, setResultText] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [sideBarOpen, setSideBarOpen] = useState(true);

  const [content, setContent] = React.useState(1);

  const handleChange5 = (event) => {
    setContent(event.target.value);
    
  };

  // const dispatch = useDispatch();
  const location = useLocation();
  const linkedinAdGenerate = useSelector(state => state.linkedinAdGenerate);
  const { linkedInAddDetails } = linkedinAdGenerate;

  const taglineGenerate = useSelector(state => state.taglineGenerate);
  const { taglineDetails } = taglineGenerate;

  const amazonDescGenerate = useSelector(state => state.amazonDescGenerate);
  const { amazonDescDetails } = amazonDescGenerate;

  const googleAdGenerate = useSelector(state => state.googleAdGenerate);
  const { googleAddDetails, googleAddHeadlines } = googleAdGenerate;

  const blogIdeasGenerate = useSelector(state => state.blogIdeasGenerate);
  const { blogIdeasDetails } = blogIdeasGenerate;

  const blogQuoteGenerate = useSelector(state => state.blogQuoteGenerate);
  const { blogQuoteDetails } = blogQuoteGenerate;

  const blogIntroGenerate = useSelector(state => state.blogIntroGenerate);
  const { blogIntroDetails } = blogIntroGenerate;

  const displayAdsGenerate = useSelector(state => state.displayAdsGenerate);
  const { displayAdsDetails } = displayAdsGenerate;
 
  


  const FaqGenerate = useSelector(state => state.FaqGenerate);
  const { FaqDetails } = FaqGenerate;

  const painAgitateGenerate = useSelector(state => state.painAgitateGenerate);
  const { painAgitateDetails } = painAgitateGenerate;
  

  const facebookAdGenerate = useSelector(state => state.facebookAdGenerate);
  const {facebookAddDetails, facebookAddSubHeading, facebookAddSubText} = facebookAdGenerate;
  



  useEffect(() => {

    
    if (type === 'LINKEDIN_ADD' && linkedInAddDetails && linkedInAddDetails.length > 0) {
      setResultText(linkedInAddDetails);
      // dispatch({ type: GENERATE_LINKEDINAD_RESET });
    }

    if (type === 'TAGLINE' && taglineDetails && taglineDetails.length > 0) {
      setResultText(taglineDetails);
    }

    if (type === 'amazonDesc' && amazonDescDetails && amazonDescDetails.length > 0) {
      setResultText(amazonDescDetails);
    }

    if (type === 'GOOGLE_ADD' && googleAddDetails && googleAddDetails.length > 0) {
      setResultText(googleAddDetails);
    }

    if (type === 'BLOG_IDEAS' && blogIdeasDetails && blogIdeasDetails.length > 0) {
      setResultText(blogIdeasDetails);
    }

    if (type === 'BLOG_QUOTE' && blogQuoteDetails && blogQuoteDetails.length > 0) {
      setResultText(blogQuoteDetails);
    }

    if (type === 'BLOG_INTRO' && blogIntroDetails && blogIntroDetails.length > 0) {
      setResultText(blogIntroDetails);
    }

    if (type === 'DISPLAY_ADS' && displayAdsDetails && displayAdsDetails.length > 0) {
      setResultText(displayAdsDetails);
    }

    if (type === 'FAQ' && FaqDetails && FaqDetails.length > 0) {
      setResultText(FaqDetails);
    }

    if (type === 'PAIN_AGITATE_SOLUTION' && painAgitateDetails && painAgitateDetails.length > 0) {
      setResultText(painAgitateDetails);
      
    }

    if (type === 'FACEBOOK_ADD' && facebookAddDetails && facebookAddDetails.length > 0 && content===1) {
   
    setResultText(facebookAddDetails);   
      
    } else if (type === 'FACEBOOK_ADD' && facebookAddSubHeading && facebookAddSubHeading.length > 0 && content===2) {
   
      setResultText(facebookAddSubHeading);   
        
    } else if (type === 'FACEBOOK_ADD' && facebookAddSubText && facebookAddSubText.length > 0 && content===3) {
   
      setResultText(facebookAddSubText);   
        
      }

    if (location.state) {
      setResultText(location.state.results);
    }

    // return () => {
    //   if (type === 'linkedinAd') {
    //     dispatch({ type: GENERATE_LINKEDINAD_RESET })
    //     setResultText([]);
    //   }
    // }
  }, [type, linkedInAddDetails, taglineDetails, amazonDescDetails, googleAddDetails, blogIdeasDetails, blogQuoteDetails, blogIntroDetails, displayAdsDetails, FaqDetails, painAgitateDetails, facebookAddDetails, content ,location.state])

  useEffect(() => {
    if (resultText.length !== 0) {
      setGenerateArray(resultText);
      let newArr = [];
      if (fileId) {
        if (type === 'GOOGLE_ADD') {
          newArr.push(['Headline', 'GOOGLE_ADD']);
          resultText.forEach(function (val) {
            newArr.push(["Headline here", val.content])
          })
        } else {
          newArr.push([type]);
          resultText.forEach(function (val) {
            newArr.push([val.content])
          })
        }
      } else {
        if (type === 'GOOGLE_ADD') {
          newArr.push(['Headline,GOOGLE_ADD']);
          resultText.forEach(function (val) {
            newArr.push([googleAddHeadlines[val.index]?.text.substr(8), val.text?.substr(8)])
          })
        } else {
          newArr.push([type]);
          resultText.forEach(function (val) {
            newArr.push([val.text?.substr(8)])
          })
        }
      }
      setCsvData(newArr);
    } else {
      setGenerateArray([]);
      setCsvData([]);
    }
  }, [resultText])

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const handleClick = (e, index) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, index]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== index));
    }
  };

  const onDelete = (index) => {
    if (fileId) {
      setResultText(
        resultText.filter((i, curIndex) => {
          return curIndex !== index;
        })
      );

    } else {
      setResultText(
        resultText.filter((i) => {
          return i.index !== index;
        })
      );
    }
    setBookmarkArray(
      bookmarkArray.filter((i, curIndex) => {
        return curIndex !== index;
      })
    )

  };

  const onSave = (index, newText) => {
    let newArr = resultText;
    newArr[index] = newText;
    setResultText(newArr);
  };

  //useEffect(async () => {
  //   await Axios.post(
  //     "/generation/tagline",
  //     {
  //       prompt: "Generating AI based output",
  //     },
  //     {
  //       headers: {
  //         Authorization:
  //           "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjYwZDFmNGQxMjkwZWU4NDRlODU5MjBlOCIsIm5hbWUiOiJBaG1hZCBBc2hyYWYifSwiaWF0IjoxNjI0MzcyNDMzfQ.Us3xOcLhUJu-0gm0SjrqmIJkKUeb5DaIOGvcsp0at_U",
  //       },
  //     }
  //   )
  //     .then(function (response) {
  //       console.log(response.data.choices);
  //       setResultText(response.data.choices);
  //     })
  //     .catch(function (error) { });
  // }, []);



  return (
    <div className="mainsoftware">
      <input className="tocheck" type="checkbox"></input>

      {sideBarOpen ? <Sidebar sidebar={sidebar} /> : (
        <div className='sidebarClose'>
          <div className="mainsoftwaresidebar_main_heading">
            <h3>Enter Details</h3>
          </div>
        </div>
      )}
      <div className="directionArrowContainer" onClick={() => setSideBarOpen(!sideBarOpen)}>
        <IconButton onClick={() => setSideBarOpen(!sideBarOpen)}>
          {sideBarOpen ? (
            <ArrowBackIosIcon style={{ color: "#52BEBA" }} />
          ) : (
            <ArrowForwardIosIcon style={{ color: "#52BEBA" }} />
          )}
        </IconButton>
      </div>
      <div className="mainsoftware__body">
        <div className="mainsoftware__body__header">
          <p>
            <FormControlLabel
              control={<>
                <Checkbox
                  checked={isCheckAll}
                  onChange={(e) => {
                    setIsCheckAll(e.target.checked);
                    !isCheckAll
                      ? setIsCheck(resultText.map((item) => item.index))
                      : setIsCheck([]);
                  }}
                  color="default"
                />


                
               
        </>
              }
              label="Select All"
              
            />
            {type==="FACEBOOK_ADD" ? 
            (<><InputLabel id="demo-simple-select-filled-label">Change Content</InputLabel>
                <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={content}
                onChange={handleChange5}
                >
                
                <MenuItem value={1}>Description</MenuItem>
                <MenuItem value={2}>SubHeading</MenuItem>
                <MenuItem value={3}>SubText</MenuItem>
                </Select></>): null}
          </p>
          <div className="mainsoftware__body__header_icons">
            <Tooltip title="Bookmark">
              <IconButton onClick={() => setIsBookmarked(!isBookmarked)}>
                {" "}
                {isBookmarked ? <BookmarkIcon className="header_icons" /> : <BookmarkBorderSharpIcon className="header_icons" />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton>
                {" "}
                <DeleteIcon className="header_icons" />
              </IconButton>
            </Tooltip>
            <span className="header_icons">|</span>
            <Tooltip title="Share">
              <IconButton>
                {" "}
                <ShareIcon className="header_icons" />
              </IconButton>
            </Tooltip>
            <CSVLink data={csvData}>
              <Tooltip title="Download">
                <IconButton>
                  {" "}
                  <GetAppIcon className="header_icons" />
                </IconButton>
              </Tooltip>
            </CSVLink>
          </div>
        </div>
        <div className="mainsoftware__body__content">
          {resultText?.map((item, index) => {
            return (
              <ResultBox
                resultBox={resultBox}
                key={item._id}
                resultText={(item.text)?.substr(8) || item.content}
                onDelete={onDelete}
                onSave={onSave}
                isCurrentBookMark={item.index ? bookmarkArray[item.index] : bookmarkArray[index]}
                bookmarkArray={bookmarkArray}
                setBookmarkArray={setBookmarkArray}
                arrData={item}
                index={fileId ? index : item.index}
                handleClick={handleClick}
                checked={item.index ? isCheck.includes(item.index) : isCheck.includes(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default MainSoftware;
